import { LoadableRoute } from 'routes/utils/loadable';

export const AdminContainer = LoadableRoute({
  loader: () => import(/* webpackChunkName: "AdminRoot" */ './Admin'),
});
